// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"134":"ddddf639","221":"79fe1f51","395":"931bf329","479":"433a1233","548":"061f8ecc","614":"46e8b7d0","844":"234bc970","875":"106ce367","913":"a1c59de1"}[chunkId] + ".chunk.js";
};